module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-hedo-02.1.7c6bd786.jpg";